var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,8.5c0-0.2,0-0.2,0-0.4c0-0.2,0-0.2,0-0.4l1.7-1.6C16,6,16,5.8,16,5.7c-0.1-0.2-0.2-0.2-0.3-0.2l-2.2-0.3 c-0.2-0.3-0.4-0.6-0.7-1l0.4-2.4c0-0.2,0-0.3-0.2-0.4c-0.2-0.1-0.3-0.1-0.4,0l-2.2,1.1c-0.3-0.2-0.7-0.2-1-0.3L8.4,0.2 C8.3,0.1,8.2,0,8,0C7.8,0,7.7,0.1,7.7,0.2L6.8,2.1C6.4,2.2,6.2,2.3,5.8,2.3L3.5,1.3c-0.1-0.1-0.2-0.1-0.4,0C3,1.4,2.9,1.5,2.9,1.7 l0.4,2.4C3,4.4,2.8,4.8,2.5,5.2L0.4,5.5C0.2,5.5,0.1,5.7,0,5.7c0,0.2,0,0.3,0.1,0.4l1.7,1.6c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3 L0.1,9.9C0,10,0,10.2,0,10.3c0.1,0.2,0.2,0.2,0.3,0.2l2.2,0.3C2.8,11.3,3,11.7,3.4,12l-0.4,2.3c0,0.2,0,0.3,0.2,0.4 c0.2,0.1,0.3,0.1,0.4,0l2.2-1.1c0.2,0.1,0.6,0.2,0.9,0.2l0.9,1.9C7.7,15.9,7.8,16,7.9,16s0.3-0.1,0.4-0.2l0.9-1.9 c0.3-0.1,0.7-0.2,1-0.3l2.2,1.1c0.2,0.1,0.3,0.1,0.4,0c0.1-0.1,0.2-0.2,0.2-0.4l-0.4-2.4c0.2-0.3,0.5-0.6,0.7-1l2.2-0.3 c0.2,0,0.2-0.2,0.3-0.2c0.1-0.1,0-0.3-0.1-0.4L14.2,8.5z M8,12.5c-2.5,0-4.6-2-4.6-4.4S5.5,3.6,8,3.6s4.6,2,4.6,4.4 S10.5,12.5,8,12.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.74041b1fdeec29f79f63a2bd3c8d77b8.svg";
export { ForwardRef as ReactComponent };